import Utils from 'src/utils';

import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_WORK_GROUPS_REQUEST = 'LOAD_WORK_GROUPS_REQUEST';
export const LOAD_WORK_GROUPS_SUCCESS = 'LOAD_WORK_GROUPS_SUCCESS';
export const LOAD_WORK_GROUPS_FAIL = 'LOAD_WORK_GROUSP_FAIL';

export const POST_WORK_GROUP_REQUEST = 'POST_WORK_GROUP_REQUEST';
export const POST_WORK_GROUP_SUCCESS = 'POST_WORK_GROUP_SUCCESS';
export const POST_WORK_GROUP_FAIL = 'POST_WORK_GROUP_FAIL';

export const PUT_WORK_GROUP_REQUEST = 'PUT_WORK_GROUP_REQUEST';
export const PUT_WORK_GROUP_SUCCESS = 'PUT_WORK_GROUP_SUCCESS';
export const PUT_WORK_GROUP_FAIL = 'PUT_WORK_GROUP_FAIL';

export const DELETE_WORK_GROUP_REQUEST = 'DELETE_WORK_GROUP_REQUEST';
export const DELETE_WORK_GROUP_SUCCESS = 'DELETE_WORK_GROUP_SUCCESS';
export const DELETE_WORK_GROUP_FAIL = 'DELETE_WORK_GROUP_FAIL';

const loadWorkGroupsRequest = () => ({ type: LOAD_WORK_GROUPS_REQUEST });
const loadWorkGroupsSuccess = (data) => ({ type: LOAD_WORK_GROUPS_SUCCESS, data });
const loadWorkGroupsFail = (err) => ({ type: LOAD_WORK_GROUPS_FAIL, err });

const postWorkGroupRequest = () => ({ type: POST_WORK_GROUP_REQUEST });
const postWorkGroupSuccess = (data) => ({ type: POST_WORK_GROUP_SUCCESS, data });
const postWorkGroupFail = () => ({ type: POST_WORK_GROUP_FAIL });

const putWorkGroupRequest = () => ({ type: PUT_WORK_GROUP_REQUEST });
const putWorkGroupSuccess = (data) => ({ type: PUT_WORK_GROUP_SUCCESS, data });
const putWorkGroupFail = () => ({ type: PUT_WORK_GROUP_FAIL });

const deleteWorkGroupRequest = () => ({ type: DELETE_WORK_GROUP_REQUEST });
const deleteWorkGroupSuccess = (data) => ({ type: DELETE_WORK_GROUP_SUCCESS, data });
const deleteWorkGroupFail = (err) => ({ type: DELETE_WORK_GROUP_FAIL, err });

export const loadWorkGroups = () => (dispatch) => {
  dispatch(loadWorkGroupsRequest());
  return communicate({ url: 'WorkGroups' })
    .then((response) => {
      dispatch(loadWorkGroupsSuccess(response.data.Data));
    }).catch((err) => {
      dispatch(loadWorkGroupsFail(err));
      toastrError(err);
    });
};

export const createWorkGroup = (params) => (dispatch) => {
  dispatch(postWorkGroupRequest());
  return communicate({ url: 'WorkGroups', method: 'post', data: params })
    .then((response) => {
      toastrSuccess(response);
      dispatch(postWorkGroupSuccess(response.data.Data));
    }).catch((err) => {
      dispatch(postWorkGroupFail(err));
      toastrError(err);
    });
};

export const updateWorkGroup = (params) => (dispatch) => {
  dispatch(putWorkGroupRequest());
  return communicate({ url: 'WorkGroups', method: 'put', data: params })
    .then((response) => {
      toastrSuccess(response);
      dispatch(putWorkGroupSuccess(response.data.Data));
    }).catch((err) => {
      dispatch(putWorkGroupFail(err));
      toastrError(err);
    });
};

export const deleteWorkGroup = (params) => (dispatch) => {
  dispatch(deleteWorkGroupRequest());
  return communicate({ url: 'WorkGroups', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteWorkGroupSuccess({ Id: params.id }));
    }).catch((err) => {
      dispatch(deleteWorkGroupFail(err));
      toastrError(err);
    });
};
